import { render, staticRenderFns } from "./TransactionDownload.vue?vue&type=template&id=2d221560&"
import script from "./TransactionDownload.vue?vue&type=script&lang=js&"
export * from "./TransactionDownload.vue?vue&type=script&lang=js&"
import style0 from "./TransactionDownload.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports